<script setup>
</script>

<template>
    <nut-drag :attract="true" :boundary="{top: 12,left: 12,right: 12,bottom: 12}" class="right-3 top-28" style="z-index: 333 !important">
        <router-link to="/service" class="w-14 h-14 flex">
            <img src="@/assets/img/icon-service-2.png" class="w-full h-full">
        </router-link>
    </nut-drag>
</template>